export class VoteParser {

    static normalizeValue(value: string | number): string | number {
        if (typeof value === "string" && !isNaN(Number(value))) {
            return parseFloat(value);
        }
        return value;
    }

    static formatMaybeNumber = (value: number | string | null | undefined) => {
        if (typeof value === "number") {
            return value.toLocaleString(undefined, { maximumFractionDigits: 2 });
        }
        return value ?? "-";
    };
}
